import { getNextStep } from '@react-query/services/next-step';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

export const useNextStep = () => {
    const { processId } = useParams();

    if (!processId) {
        throw new Error('Process ID is required to fetch the next step');
    }

    return useQuery({
        queryKey: ['next-step'],
        // biome-ignore lint/style/noNonNullAssertion: <Can use because of enabled flag>
        queryFn: () => getNextStep(processId!),
        enabled: !!processId,
    });
};
